// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import Backbone from 'backbone';
import $ from 'jquery';

import ExportModalClass from 'exports/ExportModal';
import ifCreateFromHash from 'util/ifCreateFromHash';

class CreateExportHashView extends Backbone.View<Backbone.Model> {
  override render(): this {
    function callback(): void {
      ExportModalClass.open();
    }

    $(document).on('click', '.js-create-new-export', (e) => {
      e.preventDefault();
      callback();
    });

    ifCreateFromHash('#create/export', callback);
    return this;
  }
}

export default CreateExportHashView;
